var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [
              _c(
                "text-header",
                {
                  staticClass: "atmo-hash-jump-point",
                  attrs: { id: "atmo-proposals" },
                },
                [_vm._v("Предложения участников закупочной сессии")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.purchase.status.id === "accepting"
        ? [
            _vm.purchase.is_hidden
              ? _c("p", [
                  _vm._v(
                    "Период скрытия предложений участников в закупочной сессии наступил " +
                      _vm._s(
                        _vm.$formatDateTimeIn(_vm.purchase.hide_proposals_at)
                      )
                  ),
                ])
              : _c("p", [
                  _vm._v(
                    "Предложения участников будут скрыты " +
                      _vm._s(
                        _vm.$formatDateTimeIn(_vm.purchase.hide_proposals_at)
                      )
                  ),
                ]),
          ]
        : _vm._e(),
      _vm.purchase.protocol_date
        ? _c("text-row-datetime", {
            attrs: {
              label: "Дата и время формирования итогового протокола",
              "label-cols-lg": 4,
              compact: "",
            },
            model: {
              value: _vm.purchase.protocol_date,
              callback: function ($$v) {
                _vm.$set(_vm.purchase, "protocol_date", $$v)
              },
              expression: "purchase.protocol_date",
            },
          })
        : _vm._e(),
      !(_vm.purchase.status.id === "accepting" && _vm.purchase.is_hidden)
        ? _c("b-table", {
            staticClass: "table-atmo",
            attrs: {
              fields: _vm.fields,
              items: _vm.purchase.proposals,
              "show-empty": "",
              small: "",
              responsive: "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(index)",
                  fn: function (data) {
                    return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
                  },
                },
                {
                  key: "cell(status)",
                  fn: function (data) {
                    return [
                      _vm._v(" " + _vm._s(data.item.status.title) + " "),
                      data.item.is_my_proposal
                        ? _c("span", {
                            domProps: { textContent: _vm._s("(Моё)") },
                          })
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "cell(created_at)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$formatDateTime(data.item.created_at)) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(supplier)",
                  fn: function (data) {
                    return [
                      _vm.isPurchaseSummarized ||
                      _vm.hasContract ||
                      _vm.purchase.flags.has_final_protocol
                        ? _c(
                            "router-link",
                            {
                              staticClass: "atmo-button-link",
                              attrs: {
                                target: "_blank",
                                to: {
                                  name: "OrganizationShow",
                                  params: { id: data.item.supplier.id },
                                },
                              },
                            },
                            [_vm._v(_vm._s(data.item.supplier.name))]
                          )
                        : _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                `Поставщик ${data.index + 1}`
                              ),
                            },
                          }),
                    ]
                  },
                },
                {
                  key: "cell(documents)",
                  fn: function (data) {
                    return [
                      data.item.documents.length > 0
                        ? _c(
                            "ul",
                            [
                              data.item.commercial_proposal
                                ? _c("li", [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "fs-14 col-form-label atmo-button-link d-inline-block pb-0",
                                        attrs: {
                                          href: _vm.$getAttachmentDownloadLink(
                                            data.item.commercial_proposal.id
                                          ),
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            data.item.commercial_proposal.name
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._l(data.item.documents, function (document) {
                                return _c("li", { key: document.id }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "fs-14 col-form-label atmo-button-link d-inline-block pb-0",
                                      attrs: {
                                        href: _vm.$getAttachmentDownloadLink(
                                          document.id
                                        ),
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v(_vm._s(document.name))]
                                  ),
                                ])
                              }),
                            ],
                            2
                          )
                        : _c(
                            "p",
                            {
                              staticClass:
                                "fs-14 grey-color my-auto col-form-label",
                            },
                            [_vm._v("Отсутствуют")]
                          ),
                    ]
                  },
                },
                {
                  key: "cell(actions)",
                  fn: function (data) {
                    return [
                      _c("signature-xml-info-button", {
                        attrs: {
                          title: "Электронная подпись к предложению",
                          "supplier-signature": data.item.signature,
                          size: "sm",
                          "allow-download-xml":
                            _vm.purchase.flags.is_participant &&
                            _vm.purchase.supplier_proposal.id === data.item.id,
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "empty",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "w-100 text-center" }, [
                        _vm._v("Нет поданных предложений"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              377130981
            ),
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }